import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'app/snackbar/snackbar.component';
import { ApiService } from 'app/ts/ApiService';
import { ClientStoreService } from 'app/ts/services/client-store.service';

@Component({
  selector: 'app-next-of-kin-details',
  templateUrl: './next-of-kin-details.component.html',
  styleUrls: ['./next-of-kin-details.component.scss', '../../forms.shared.scss']
})
export class NextOfKinDetailsComponent implements OnInit {

  @Output() updateStepEvent = new EventEmitter<number>();
  @Output() previousStepEvent = new EventEmitter<number>();
  
  nextOfKinDetails: FormGroup;
  // client$ = this.clientStore.client$;
  client: any;

  constructor(private api: ApiService,
      private formBuilder: FormBuilder,
      private snackbar: MatSnackBar,
      private clientStore: ClientStoreService) { }

  async ngOnInit() {
    this.nextOfKinDetails = this.formBuilder.group({
        name: ['', Validators.required],
        surname: ['', Validators.required],
        email: ['', Validators.required],
        mobileNumber: ['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
        relationship: ['', Validators.required]
      });

    this.clientStore.client$.subscribe(client => {     // async updates
      this.client = client;
    });
  }

  private isFormEmpty(form: FormGroup): boolean {
    return Object.values(form.value).every(value =>
      value === null || value === undefined || value === ''
    );
  }

  save() {
    
    if (!this.nextOfKinDetails.valid) {
      this.openSnackBar('Please complete all Next of Kin details before saving.', 'error-snackbar');
      return;
    }

    var nextOfKinPayload = {
      id: 0,
      clientId: this.client.clientId,
      name: this.nextOfKinDetails.get('name')?.value,
      surname: this.nextOfKinDetails.get('surname')?.value,
      email: this.nextOfKinDetails.get('email')?.value,
      mobileNumber: this.nextOfKinDetails.get('mobileNumber')?.value,
      relationshipId: this.nextOfKinDetails.get('relationship')?.value
    };

    if (this.nextOfKinDetails.valid && this.nextOfKinDetails.value) {
      this.api.saveNextOfKinDetails(nextOfKinPayload).subscribe((response: any) => {
      if (response.message === 'Success') {
        this.openSnackBar('Next of Kin details saved successfully.', 'success-snackbar');
        this.updateStepEvent.emit();
      } else {
        this.openSnackBar('Error saving Next of Kin details: ' + response.message, 'error-snackbar');
        
      }
      },
        (error) => {
          this.openSnackBar("Error saving Next Of Kin Details", 'error-snackbar');
        });
    } else {
      this.updateStepEvent.emit();
    }
  }

  openSnackBar(msg: string, panel: string) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: msg,
        panelClass: [panel],
        duration: 8000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
    }
    

}
